module.exports = __webpack_public_path__ + "img/gotg.f303ed13.svg";